import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataFetchService {

  constructor(private _http: HttpClient) { }

   reportData(scooterimei,parameter,startTs,endTs) {//,startTs,endTs
    let startTsSplit = startTs.split("T");
    let endTsSplit = endTs.split("T");
    startTs = startTsSplit[0]+" "+startTsSplit[1];
    endTs = endTsSplit[0]+" "+endTsSplit[1];
     return this._http.get<any[]>("https://us-central1-batterypoolapp.cloudfunctions.net/bigquery-fetch-data"+'/?imei='+scooterimei+'&parameter='+parameter+'&start='+startTs+'&end='+endTs)//+'&start='+startTs+'&end='+endTs
       .pipe(map((result: any) => result));
   }
}
